import React from "react";
import HeroSection from "../components/HeroSection";
import ImproveSkills from "../components/ImproveSkills";
import QuoteSection from "../components/QuoteSection";
import ChefsSection from "../components/ChefsSection";
const Home = () => {
  return (
    <div>
      <HeroSection />
      <ImproveSkills />
      <QuoteSection />
      <ChefsSection />
    </div>
  );
};

export default Home;
